import { all, call, put, take, takeLatest } from 'redux-saga/effects';
import { customerOperations, customerTypes } from '../../store/customer';
import { getBooking, updateBookingDelivery } from '../../api/booking';

import { DAS_UPDATE_CUSTOMER_BOOKING_DELIVERIES_FAILED } from '../../constants/errors';
import { GET_CUSTOMER_SUCCESS } from '../../store/customer/types';
import { bookingOperations } from '../../store/booking';
import constants from '../../constants';
import { createError } from '../../store/errors';
import get from 'lodash/get';
import { goToRoute } from '../../lib/router';
import { messageOperations } from '../../store/messages';
import { updateCustomer } from '../../api/customer';

const { UPDATE_CUSTOMER_BOOKING_DELIVERIES } = customerTypes;

export const performUpdateCustomerDeliveries = function* performUpdateCustomerDeliveries({
  payload,
}) {
  const { bookingRefs, fields, redirectPath } = payload;
  const { updateCustomerDeliveriesSuccess } = customerOperations;
  const { sendMessage } = messageOperations;
  const {
    address_1,
    address_2,
    address_3,
    city,
    post_code: postcode,
    county,
    country_id,
  } = fields?.address ?? {};
  const bookingDeliveriesFields = {
    address: {
      address_1,
      address_2,
      address_3,
      city,
      postcode,
      county,
      country_id,
    },
  };
  try {
    const bookings = yield all(bookingRefs.map(ref => call(getBooking, ref)));
    const updateBookings = [];
    const allErrors = [];

    bookings.forEach(({ booking, errors }) => {
      const { reference } = booking;
      const allocationId = get(booking, 'delivery.0.allocation_id');

      if (allocationId) {
        updateBookings.push({ reference, allocationId });
      }
      if (errors) {
        allErrors.push(...errors);
      }
    });

    const data = yield all([
      call(updateCustomer, fields),
      ...updateBookings.map(({ reference, allocationId }) =>
        call(
          updateBookingDelivery,
          reference,
          allocationId,
          bookingDeliveriesFields,
        ),
      ),
    ]);

    data.forEach(({ errors }) => {
      if (errors) {
        allErrors.push(...errors);
      }
    });
    if (allErrors.length > 0) {
      // Handle web service errors.
      yield all(allErrors.map(error => put(createError(error))));
    } else {
      yield put(updateCustomerDeliveriesSuccess());
      yield take(GET_CUSTOMER_SUCCESS);
      yield all(bookingRefs.map(ref => put(bookingOperations.getBooking(ref))));
      yield put(goToRoute(redirectPath));
      yield put(
        sendMessage({
          type: 'success',
          displayType: 'toast',
          message: constants.UPDATE_CUSTOMER_BOOKING_DELIVERIES_SUCCESS,
        }),
      );
    }
  } catch (error) {
    // Handle errors with the request itself, produce default error.
    yield put(
      createError({
        code: DAS_UPDATE_CUSTOMER_BOOKING_DELIVERIES_FAILED,
      }),
    );
  }
};

export default takeLatest(
  UPDATE_CUSTOMER_BOOKING_DELIVERIES,
  performUpdateCustomerDeliveries,
);
